<div class="tracker" *ngIf="mode && milestoneObj">
   <div id="trackerLine" class="tracker-line">
      <div class="travelled" [style.flex-basis.%]="percent"></div>
      <div class="to-travel" [style.flex-basis.%]="100 - percent"></div>
   </div>

   <div class="timeline-container">
      <div id="trackerDisplay" #trigger class="tracker-displays" *ngFor="let p of positions; let i = index"
         (mouseenter)="showTooltip( p, trigger )" (mouseleave)="tooltipRef.detach()">
         <div id="timelineItem" class="timeline-item" [ngClass]="{
                         'timeline-item-first': i === 0,
                         'timeline-item-last': i === positions.length - 1
                       }">
            <div id="trackerCircle" class="tracker-circle" [class.visited]="current.position > p"></div>
            <ng-container *ngIf="current.position === p;">
               <button id="trackerStatus" mat-button class="tracker-status" [class.delayed]="isDelayed" color="accent">
                  <mat-icon id="trackerIcon" [svgIcon]="current.icon"></mat-icon>
                  <span id="trackerLabel" class="tracker-label">{{current.label}}</span>
               </button>
            </ng-container>
            <div id="milestoneDisplay" class="milestone-display">
               <span id="milestoneStatus" class="status" [style.font-weight]="p > current.position ? 'normal' : 'bold'">{{displayMilestone( p ).label}}</span>
               <span id="milestoneDate" class="date">{{displayMilestone( p ).date | date:'M/d/yy'}}</span>
            </div>
         </div>
      </div>
   </div>
</div>
